import React, { useEffect, useRef } from "react"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"

export default function SubNavigation({ current, id }) {
  const activeItem = useRef()

  const handleScroll = () => {
    var height = document.documentElement.scrollHeight - window.innerHeight
    var scrollY = window.pageYOffset
    var progress = Math.round((scrollY / height) * 100)
    if (activeItem.current) {
      activeItem.current.style.width = progress + "%"
    }
  }

  const setActive = name => {
    if (current === name) {
      return "sub-navigation--active"
    } else if (!current) {
      return "sub-navigation--active"
    } else {
      return null
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
  })

  const renderChildren = () => {
    const parentMenu = findObject(menuData, "id", id)
    if (parentMenu === undefined) {
      return null
    }
    const menu = parentMenu.children
    const location = menu.findIndex(item => item.id.includes(current))

    let children = menu.map((item, index) => {
      return (
        <li
          key={index}
          className={setActive(item.id, index)}
          style={{ flex: 100 / menu.length }}
        >
          <div className="sub-navigation__progress">
            <div
              className={
                index < location
                  ? "sub-navigation__progress__bar sub-navigation__progress__bar--full"
                  : "sub-navigation__progress__bar"
              }
              ref={item.id === current ? activeItem : null}
            />
          </div>

          <Link className="sub-navigation__item" to={item.href}>
            <div className="sub-navigation__item__text">
              <div className="sub-navigation__item__text__title">
                {item.name}
              </div>
            </div>
          </Link>
        </li>
      )
    })

    return children
  }

  const menuLength = () => {
    const parentMenu = findObject(menuData, "id", id)
    if (parentMenu === undefined) {
      return null
    }
    const menu = parentMenu.children
    return menu.length
  }

  return (
    <nav
      className={`sub-navigation sub-navigation--desktop sub-navigation--${menuLength()}`}
    >
      <ul className="container">{renderChildren()}</ul>
    </nav>
  )
}
